<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-router-link icon="fa fa-home" to="/anasayfa" :exact="true">Ana Sayfa</sidenav-router-link>

      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA"
                           icon="fas fa-chart-line" to="/rapor"
                           :exact="true">Rapor
      </sidenav-router-link>

      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-edit" class=""
                           to="/kisi/liste"
                           :exact="true">Hocalar ve Kurlar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.HOCA" icon="fa fa-user"
                           to="/ogrenci/liste"
                           :exact="true">Kursiyerlerim
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-user"
                           to="/ogrenci/liste"
                           :exact="true">Kursiyerler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-user"
                           to="/ogrenci/liste?silinenlerMi=true"
                           :exact="true">Silinen Kursiyerler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-book" to="/sinif/liste" :exact="true">
        Sınıflar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-book" to="/sinif/liste?arsivMi=true" :exact="true">
        Arşivdeki Sınıflar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA"
                           icon="fas fa-calendar-alt"
                           to="/baslayacak-devam-edenler"
                           :exact="true">Başlayacaklar ve Devam Edenler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-folder" to="/dosyalar"
                           :exact="true">Dosyalar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-globe"
                           to="/yuzyuze-egitim-yerler"
                           :exact="true">Yüzyüze Eğitim İlçeleri
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA && false" icon="fa fa-home"
                           to="/okullar"
                           :exact="true">Yüzyüze Eğitim Okullar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-clock"
                           to="/seanslar"
                           :exact="true">Yüzyüze Eğitim Seanslar
      </sidenav-router-link>
<!--      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-hand-paper" to="/etkinlik"
                           :exact="true">Etkinlikler
      </sidenav-router-link>-->
      <sidenav-router-link v-if="kullaniciYetki === Yetki.TALEBE && !ziraatKatilimMi" icon="fas fa-user" to="/profilim"
                           :exact="true">Profilim
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciCinsiyet === 2" icon="fas fa-list" to="/seminerler"
                           :exact="true">Seminerler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.TALEBE && baseDomainMi" icon="fas fa-check" to="/sertifika"
                           :exact="true">Sertifikalarım
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && baseDomainMi" icon="fas fa-file" to="/sertifika-olusturucu"
                           :exact="true">Sertifika Oluşturucu
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.TALEBE && hususiMi"
                           icon="fas fa-upload" to="/seviye-tespit"
                           :exact="true">Seviye Tespit
      </sidenav-router-link>
<!--      <sidenav-router-link v-if="kullaniciYetki === Yetki.SUPERADMIN" icon="fas fa-file-excel" to="/raporlarim"
                           :exact="true">Raporlarım
      </sidenav-router-link>-->
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from '@/vendor/libs/sidenav'
import { getCinsiyet, getRole } from '@/utils/jwtOperations'
import { Yetki } from '@/utils/enums'

export default {
  name: 'app-layout-sidenav',
  data () {
    return {
      kullaniciYetki: 0,
      kullaniciCinsiyet: getCinsiyet(),
      uluedMi: false,
      Yetki
    }
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    tiklandi () {
    },
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  },
  mounted () {
    this.kullaniciYetki = getRole()
  }
}
</script>
